import NavBreadcrumbRoot from './Root';
import NavBreadcrumbItem from './Item';

const NavBreadcrumb = {
  Root: NavBreadcrumbRoot,
  Item: NavBreadcrumbItem,
};

export default NavBreadcrumb;
